<template>
  <div class="input-group">
    <select class="form-control"
            :disabled="isProcessing || !(officeId)"
            v-model="selectedValue"
            @change="onChange">
      <option value="">(未選択)</option>
      <option v-for="staff in staffs" :value="staff.id" :key="staff.id">
        {{staff.display_name}}
      </option>
    </select>
    <div class="input-group-append" v-show="isProcessing">
      <a class="btn" type="button" onclick="education_fields()"><i class="fa fa-spinner fa-spin"></i></a>
    </div>
  </div>
</template>

<script setup>
import api from '@/libs/Api'
import Constants from '@/constants'
import { ref, watch, onMounted, toRef } from 'vue'
import { useExecutor } from '@/libs/Executor'

const { exec } = useExecutor()

const props = defineProps({
  officeId: Number,
  dataSource: null,
  modelValue: Number
})

const emit = defineEmits(['change', 'input'])

const staffs = ref([])
const selectedValue = ref()
const isProcessing = ref(false)
const officeIdRef = toRef(props, 'officeId')
const valueRef = toRef(props, 'modelValue')

onMounted(() => {
  selectedValue.value = props.value
  load()
})

const load = () => {
  exec(async () => {
    if (!officeIdRef.value) return
    isProcessing.value = true
    if (props.dataSource) {
      staffs.value = props.dataSource
      if (staffs.value.length === 1) {
        selectedValue.value = staffs.value[0].id
        onChange(null)
      }
      isProcessing.value = false
      return Promise.resolve()
    } else {
      const res = await api.getStaffs(Constants.QUERY_MODE_TRIM_GET, 1, officeIdRef.value)
      staffs.value = res
      isProcessing.value = false
    }
  })
}

const onChange = (event) => {
  emit('update:modelValue', selectedValue.value)
  emit('change', event)
}

watch(valueRef, () => {
  selectedValue.value = valueRef.value
})

watch(officeIdRef, load)

</script>
